import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { grayLight45, fontSizeMedium, fontSize4XSmall, fontSize2XSmall, fontWeightBold, fontSizeXSmall, black } from '../../constants/principles'
import RadioQuestion from './RadioQuestion'
import { breakpoints } from '../../constants'

export default ({ questionSubheader, answers = [], showClose, onClickAnswer, onClickClose, addImpressions, updateGlobalState, surveyKey = 'icosurvey', backgroundColor, fontColor }) => {
  const questionTitle = 'Help Us Improve Instant Cash Offer'
  const [answered, setAnswered] = useState(false)
  const [faded, setFaded] = useState(false)
  const [shown, setShown] = useState(false)

  const onClose = () => {
    updateGlobalState({ fireAnalytics: `${surveyKey}_close_btn` })
    onClickClose && onClickClose()
  }

  const onAnswer = () => {
    updateGlobalState({ fireAnalytics: `${surveyKey}_submit_btn` })
    onClickAnswer && onClickAnswer()
  }

  useEffect(() => {
    if (!shown) {
      setShown(true)
      addImpressions(surveyKey)
    }

    answered && !faded && setTimeout(setFaded(true), 500)
  }, [answered, faded, shown, surveyKey, addImpressions])

  return (
    <ContainerDiv backgroundColor={backgroundColor} fontColor={fontColor}>
      <HeaderDiv>
        <StyledI iconSize={180}>&#xe800;</StyledI>
        <TitleDiv>{questionTitle}</TitleDiv>{' '}
        {showClose && (
          <StyledSpan onClick={() => onClose()}>
            <StyledI iconSize={80}>&#xe801;</StyledI>
          </StyledSpan>
        )}
      </HeaderDiv>
      <SubtitleDiv>{answered && faded ? '' : questionSubheader}</SubtitleDiv>
      <FadeOutDiv answered={answered} faded={faded}>
        {answers.map(answer => {
          return (
            <RadioQuestion
              key={answer.id}
              text={answer.text}
              value={answer.text}
              name="test"
              onClick={() => {
                addImpressions(`${surveyKey}_${answer.id}`)
                setAnswered(true)
                onAnswer()
              }}
            />
          )
        })}
        <LegalDiv>This is only for our research. Your response will not affect your Offer.</LegalDiv>
      </FadeOutDiv>
      <FadeInDiv answered={answered && faded}>Thank you for your response!</FadeInDiv>
    </ContainerDiv>
  )
}

const StyledI = styled.i`
  font-family: 'fontello';
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  font-size: ${p => p.iconSize}%;
`
//Start fading after answered. remove from DOM after they have finished fading
const FadeOutDiv = styled.div`
  opacity: ${p => (p.answered ? 0 : 1)};
  transition: opacity 2s;
  display: ${p => (p.faded ? 'none' : 'block')};
  font-size: ${fontSize2XSmall};
`
const FadeInDiv = styled.div`
  opacity: ${p => (p.answered ? 1 : 0)};
  transition: opacity 2s;
  font-size: 18px;
  ${p => p.answered && `padding-bottom: 120px;`}
  padding-left:8px;
`

const ContainerDiv = styled.div`
  width: 100%;
  @media (min-width: ${breakpoints.lg}px) {
    width: 550px;
  }
  background-color: ${p => p.backgroundColor || grayLight45};
  color: ${p => p.fontColor || black};
  padding: 8px 16px;
  border-radius: 8px;
  align-self: center;
  display: flex;
  flex-direction: column;
`
const TitleDiv = styled.div`
  padding-left: 8px;
`
const HeaderDiv = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${fontSizeMedium};
  font-weight: ${fontWeightBold};
  align-items: center;
`
const SubtitleDiv = styled.div`
  padding-bottom: 16px;
  padding-top: 16px;
  font-size: ${fontSizeXSmall};
  font-weight: normal;
`
const LegalDiv = styled.div`
  font-size: ${fontSize4XSmall};
  padding-top: 32px;
  font-weight: normal;
`
const StyledSpan = styled.div`
  align-self: flex-start;
  cursor: pointer;
  padding-left: 24px;
`
